import React from 'react';

const AyurvedicDietPage = () => {
  return (
    <div className="container mx-auto py-12 px-4 bg-gray-100 font-sans">
      
      <h1 className="text-4xl font-bold text-center mb-12 uppercase text-[#4a6b2e]">Ayurvedic Diet</h1>
      
      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Article 1: Introduction to Ayurvedic Diet */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://www.drjasnasayurveda.com/images/blog/image161.png" 
            alt="Ayurvedic food" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Nutrition</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Beginner's Guide to Ayurvedic Eating</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Explore the fundamental principles of Ayurvedic nutrition and how to incorporate them into your daily meals for better digestion and overall health.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 2: Recipes for Vata Dosha */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://www.expertreviewsbestricecooker.com/wp-content/uploads/2023/11/best-rice-for-vata-dosha.png" 
            alt="Vata balancing food" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Vata / Recipes</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Nourishing Recipes for Vata Dosha</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Discover warming and grounding recipes that help calm and balance Vata dosha, especially during colder months.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 3: Recipes for Pitta Dosha */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://yogajala.com/wp-content/uploads/2022/05/1-9.jpg" 
            alt="Pitta balancing food" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Pitta / Recipes</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Cooling Foods for Pitta Dosha</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Learn how to pacify Pitta with refreshing and cooling foods that help reduce inflammation and excess heat in the body.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 4: Recipes for Kapha Dosha */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://yogajala.com/wp-content/uploads/2022/10/The-Ideal-Kapha-Diet-Eating-For-Your-Dosha.jpg" 
            alt="Kapha balancing food" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Kapha / Recipes</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Light and Spicy Meals for Kapha Dosha</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Find invigorating and light recipes that help stimulate metabolism and prevent sluggishness in Kapha-dominant individuals.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 5: Digestive Herbs */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://www.health2wellnessblog.com/wp-content/uploads/2020/07/Top-10-Benefits-of-Using-Herbal-Medicines.jpg" 
            alt="Herbs and spices" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Digestion</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Top Ayurvedic Herbs for Healthy Digestion</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Learn about key herbs and spices like ginger, cumin, and fennel that support your digestive fire (Agni) and promote gut health.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 6: Seasonal Eating */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://i.ytimg.com/vi/Maftbqg4ua0/maxresdefault.jpg" 
            alt="Seasonal fruits and vegetables" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Seasonal</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Eating with the Seasons: An Ayurvedic Approach</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Understand the importance of eating seasonal foods to stay in harmony with nature and maintain balance throughout the year.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default AyurvedicDietPage;